/**
 * @fileoverview
 * Input Radio Component - Radio button group with form control support
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-radio',
  standalone: true,
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioComponent),
      multi: true,
    },
  ],
  templateUrl: './input-radio.component.html',
  styleUrl: './input-radio.component.css',
})
export class InputRadioComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() name: string = 'radio-group';
  @Input() options: { id: any; label: string }[] = [];
  @Input() showAsterisk: boolean = false;

  selectedValue: any = null;

  // ControlValueAccessor methods
  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectionChange(value: any) {
    this.selectedValue = value;
    this.onChange(value);
    this.onTouched();
  }
}

